import React, { memo } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { TextInput } from '../TextInput/TextInput';
export const DropDownItem = MenuItem;
export const Dropdown = memo((props) => {
    return React.createElement(TextInput, { select: true, ...props });
});
